<template>
  <div style="height: 100%;background-color: white">
    <div style="height: 50px;padding-top: 20px;margin: 0 20px">
      <el-button type="primary" plain icon="el-icon-plus" @click="addProjectShow()">新增</el-button>
<!--      <el-input prefix-icon="el-icon-search" placeholder="输入项目名称查询" v-model="searchKeyword" style="width: 300px"></el-input>-->
<!--      <el-button type="primary" @click="getSearchData()">查询</el-button>-->
    </div>
    <div style="max-height: calc(100% - 120px);overflow-y: auto;margin: 0 20px">
      <el-table :data="tableData" border highlight-current-row ref="singleTable">
        <el-table-column
          type="index"
          label="编号"
          width="70"
          align="center">
        </el-table-column>
        <el-table-column
          prop=""
          label="所属组织"
          min-width="80"
          align="center">
        </el-table-column>
        <el-table-column
          prop=""
          label="项目名称"
          min-width="80"
          align="center">
        </el-table-column>
        <el-table-column
          prop=""
          label="收费金额"
          min-width="70"
          align="center">
        </el-table-column>
        <el-table-column
          prop=""
          label="备注"
          min-width="70"
          align="center">
        </el-table-column>
        <el-table-column align="center" label="操作" width="150">
          <template slot-scope="scope">
            <i title="更新" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editChargePrice(scope.row)"></i>
            <i title="删除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delChargePrice(scope.row)"></i>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-top: 10px;height: 40px;text-align: center">
      <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                     :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalCells"
                     layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>
    <el-dialog :visible.sync="addShow" v-if="addShow" width="500px"
               :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <span>收费价格</span>
        <div class="line-title"></div>
      </div>
      <add-edit-price :addEditObj="addEditObj" v-model="addShow"></add-edit-price>
    </el-dialog>
  </div>
</template>

<script>
import addEditPrice from './components/addEditPrice'
export default {
  name: 'chargePrice',
  components: {addEditPrice},
  data () {
    return {
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      tableData: [{id: 1, name: 11}],
      searchKeyword: '',
      addShow: false,
      addEditObj: {
        row: ''
      }
    }
  },
  created () {
  },
  methods: {
    getSearchData () {},
    addProjectShow () {
      this.addShow = true
    },
    editChargePrice (row) {
      this.addEditObj.row = row
      this.addShow = true
    },
    delChargePrice (row) {
      this.$confirm('此操作将永久删除该项目价格, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {})
    },
    handleSizeChange (val) {
      this.pageSize = val
    },
    handleCurrentChange (val) {
      this.currentPage = val
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/chargePrice.vue